const formatReportName = (val: string) => {
	if (val) {
		const regex = /[^a-z0-9_]/g
		return val
			.toLowerCase()
			.replace(/\s/g, '_')
			.replace(regex, '')
	}

	return val
}

export default formatReportName
